const DEVICE_ID_KEY = 'deviceId'

let deviceId = null
export function getDeviceId() {
  if (!deviceId) {
    try {
      deviceId = localStorage.getItem(DEVICE_ID_KEY) || null
    } catch {
      /* empty */
    }
  }

  if (!deviceId) {
    try {
      deviceId = crypto.randomUUID()
    } catch {
      /* empty */
    }

    if (!deviceId) {
      throw new Error('Could not generate deviceId')
    }

    localStorage.setItem(DEVICE_ID_KEY, deviceId)
  }

  return deviceId
}
